// The one labelled ad on a living story (Asana 1219383957503739).

const time = (value) => (value ? new Date(value).getTime() : NaN);

export const liveSponsor = (story, now = Date.now()) => {
    const { sponsorName, sponsorImageUrl, sponsorUrl } = story || {};
    if (!sponsorName || !sponsorImageUrl || !sponsorUrl) {
        return null;
    }
    if (time(story.sponsorStartsAt) > now || time(story.sponsorEndsAt) <= now) {
        return null;
    }
    return { name: sponsorName, imageUrl: sponsorImageUrl, url: sponsorUrl };
};

// The page is ISR: rebuild it when the slot goes up or comes down, not a day later.
export const sponsorRevalidate = (story, revalidate, now = Date.now()) => {
    const next = [time(story?.sponsorStartsAt), time(story?.sponsorEndsAt)]
        .filter((at) => at > now)
        .map((at) => Math.ceil((at - now) / 1000));
    return Math.max(60, Math.min(revalidate, ...next));
};
